import { ExternalLinkIcon, LetterCloseIcon, PhoneLandlineIcon } from "assets";
import { dataTestIds } from "data-testids";
import _join from "lodash/join";
import _compact from "lodash/compact";
import { IAgency } from "models";
import { getUrlWithProtocol } from "shared/utils/getUrlWithProtocol";

export const SELF_REPRESENTED_REF_NUMBER = 50;

export const displayAgentLists = (agentLists: IAgency[]) => {
  return agentLists.map((agent) => {
    const address = _join(
      _compact([
        agent.address?.addressLine1,
        agent.address?.addressLine2,
        agent.address?.addressLine3,
        agent.address?.addressLine4,
        agent.address?.country,
        agent.address?.postCode,
      ]),
      ", "
    );

    const phoneNumbers = _join(
      _compact(
        [agent.phone, agent.phone2, agent.phone3, agent.phone4].map((num) =>
          num?.trim()
        )
      ),
      ", "
    );

    return (
      <div
        key={agent.refNumber}
        className="border-b border-white/10 pb-1.5 last:border-b-0"
        data-testid={`${dataTestIds.profile["Profile.Agency.agencyDetails"]}-${agent.name}`}
      >
        {agent.description && <p className="text-s">{agent.description}</p>}

        {agent.website ? (
          <a
            className="group flex items-center gap-2 text-color-brand-one hover:text-color-brand-two dark:text-blue-aquamarine dark:hover:text-white"
            href={getUrlWithProtocol(agent.website)}
            target="_blank"
            rel="noopener noreferrer"
            data-testid={`${dataTestIds.profile["Profile.Agency.agencyDetails.name"]}`}
          >
            <h2 className="text-s font-semibold leading-4">{agent.name}</h2>
            <ExternalLinkIcon className="invisible group-hover:visible" />
          </a>
        ) : (
          <div
            className="mb-1 text-color-brand-one dark:text-blue-aquamarine"
            data-testid={`${dataTestIds.profile["Profile.Agency.agencyDetails.name"]}`}
          >
            <h2 className="text-s font-semibold leading-4">{agent.name}</h2>
          </div>
        )}

        {address && (
          <p
            className="text-s"
            data-testid={`${dataTestIds.profile["Profile.Agency.agencyDetails.address"]}`}
          >
            {address}
          </p>
        )}

        {phoneNumbers.length > 0 && (
          <div className="flex items-center gap-2 dark:text-white/90">
            <PhoneLandlineIcon className="text-grey-void dark:text-white/90" />
            <span
              className="text-s"
              data-testid={`${dataTestIds.profile["Profile.Agency.agencyDetails.phone"]}`}
            >
              {phoneNumbers}
            </span>
          </div>
        )}

        {agent.email && (
          <a
            href={`mailto:${agent.email}`}
            className="flex items-center gap-2 font-medium text-color-brand-one break-word hover:text-color-brand-two dark:text-blue-aquamarine dark:hover:text-white"
            data-testid={`${dataTestIds.profile["Profile.Agency.agencyDetails.email"]}`}
          >
            <LetterCloseIcon width={13} className="shrink-0" />
            {agent.email}
          </a>
        )}
      </div>
    );
  });
};
